Modules.EmailSubscription.Helpers.Selectors = require('./helpers/selectors');

Modules.EmailSubscription.Views.CouponsAlerts = require('./views/coupons_alerts');

Modules.EmailSubscription.Views.MerchantAlerts = require('./views/merchant_alerts');

Modules.EmailSubscription.Models.Subscription = require('./models/subscription');

Modules.EmailSubscription.Application = {
  initializeCouponsEmailAlerts: function() {
    var $couponsAlerts;
    $couponsAlerts = $(Modules.EmailSubscription.Helpers.Selectors.COUPONS_ALERTS_SELECTOR);
    return new Modules.EmailSubscription.Views.CouponsAlerts({
      el: $couponsAlerts,
      model: new Modules.EmailSubscription.Models.Subscription()
    });
  },
  moveEmailSubscriptionDiv: function() {
    var el;
    el = $(".touch-coupons-list li:eq(5)");
    $('.coupon-email-alert').insertBefore(el);
  },
  initializeMerchantEmailAlerts: function() {
    var $merchantAlerts;
    $merchantAlerts = $(Modules.EmailSubscription.Helpers.Selectors.MERCHANT_ALERTS_SELECTOR);
    return new Modules.EmailSubscription.Views.MerchantAlerts({
      el: $merchantAlerts,
      model: new Modules.EmailSubscription.Models.Subscription()
    });
  }
};

module.exports = Modules.EmailSubscription.Application;

